import { getSalonAdminApiBaseUrl } from "./apiConfig";
import { PORTAL_HEADER } from "../../admin-shared/storage";

const rawApiBase = getSalonAdminApiBaseUrl();

export const API_BASE = rawApiBase.replace(/\/+$/, "");
export const PORTAL_ID = "workspace";

export function hasHqSession() {
  return Boolean(localStorage.getItem("enterprise_salon_userId"));
}

export function hqFetch(input, init = {}) {
  const headers = new Headers(init.headers || {});
  headers.set(PORTAL_HEADER, PORTAL_ID);
  return fetch(input, {
    ...init,
    headers,
    credentials: init.credentials ?? "include",
  });
}

export const api = (endpoint, options = {}) => {
  const normalizedEndpoint = endpoint?.startsWith("/") ? endpoint : `/${endpoint || ""}`;

  return fetch(`${API_BASE}${normalizedEndpoint}`, {
    method: options.method || "GET",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    credentials: "include",
    ...options,
  });
};
